import React from 'react';
import {
    CircularProgress,
    Dialog, DialogContent, DialogTitle,
    LinearProgress, Typography,
} from '@material-ui/core';

const ImportProgressDialog = ({ open, current, total }) => {
    const reading = total === 0;
    const pct     = total > 0 ? Math.round((current / total) * 100) : 0;

    return (
        <Dialog open={open} maxWidth="xs" fullWidth disableBackdropClick disableEscapeKeyDown>
            <DialogTitle disableTypography>
                <Typography variant="h6" style={{ fontWeight: 600 }}>
                    {reading ? 'Leyendo archivo...' : 'Importando artículos...'}
                </Typography>
            </DialogTitle>

            <DialogContent style={{ paddingBottom: 28 }}>
                {reading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 0' }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <>
                        <Typography
                            variant="h5"
                            align="center"
                            style={{ fontWeight: 700, marginBottom: 16, color: '#1565C0', letterSpacing: 1 }}
                        >
                            {current}
                            <span style={{ color: '#9e9e9e', fontWeight: 400 }}> / {total}</span>
                        </Typography>

                        <LinearProgress
                            variant="determinate"
                            value={pct}
                            style={{ height: 10, borderRadius: 5 }}
                        />

                        <Typography variant="body2" align="center" style={{ marginTop: 8, color: '#757575' }}>
                            {pct}%
                        </Typography>
                    </>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default ImportProgressDialog;
